module.exports = __webpack_public_path__ + "img/bus-1.6d73db67.jpg";